/* eslint-disable no-unused-vars */
import React from 'react'
import ClearUserHistory from '../../Services/Mutations/ClearUserHistory'
import GetBoxOfficeVideos from '../../Services/Queries/GetBoxOfficeVideos'
import ContentAnalytics from '../../Services/Mutations/ContentAnalytics'
import VideoAnalytics from '../../Services/Mutations/VideoAnalytics'
import { Button } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Preview from '../content/Preview'
import VideoPreview from '../video/Preview'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'

class ClearHistory extends React.Component {
	toastStyle = {
		position: 'top-right',
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}

	constructor(props) {
		super(props)
		this.state = {
			boxOfficeVideos: [],
			count: 0,
			disablePrev: true,
			disableNext: true,
			paginationCount: 1,
		}
	}

	// componentDidMount = async () => {
	// await this.GetBoxOfficeVideos()
	// }
	ContentAnalytics = async data => {
		const input = {
			input: {
				contentID: data.contentID,
			},
		}
		console.log(input, 'contentAnalyticsInput')
		const contentAnalytics = await ContentAnalytics(input)
		console.log(contentAnalytics, 'contentanalytics======')
	}

	VideoAnalytics = async data => {
		const input = {
			input: {
				videoID: data.PK,
			},
		}
		console.log(input, 'VideoAnalyticsInput')
		const videoAnalytics = await VideoAnalytics(input)
		console.log(videoAnalytics, 'VideoAnalytics======')
	}

	GetBoxOfficeVideos = async nextSet => {
		const input = {
			input: {
				PK: 's',
				SK: 's',
				UUID: 'testUser',
				appInfoFrontEnd: {
					appVersionNumber: 65,
				},
				paginationCount: this.state.paginationCount,
				initialBoxofficeLoad: !(nextSet !== undefined && nextSet !== null && nextSet),
			},
		}
		console.log(input, 'getBoxOfficeInput==========')
		const getBoxOfficeVideos = await GetBoxOfficeVideos(input)
		console.log(getBoxOfficeVideos, 'getboxOfficeVideos======')
		this.setState({
			boxOfficeVideos: [...this.state.boxOfficeVideos, ...getBoxOfficeVideos.vidApp],
			paginationCount: parseInt(this.state.paginationCount, 10) + 1,
		})
	}

	ClearUserHistory = async () => {
		this.setState({ count: 0, disableNext: false, boxOfficeVideos: [], paginationCount: 1 })
		const input = {
			type: 'clearHistory',
		}
		console.log(input, 'input============')
		const clearHistory = await ClearUserHistory(input)
		console.log(clearHistory, 'clearUserHistory=====')
		if (clearHistory.statusCode === 'A304') {
			this.GetBoxOfficeVideos()
			toast.success('Cleared User History Successfully', this.toastStyle)
		} else {
			toast.error('Failed to Clear User History', this.toastStyle)
		}
	}

	handlePreviousPreview = boxOfficeVideos => {
		this.setState({ disableNext: false })
		const finalcount = this.state.count
		if (finalcount === 0) {
			this.setState({ disablePrev: true })
		} else if (finalcount > 0) {
			this.setState({ disablePrev: false })
			this.setState({ count: finalcount - 1 })
		}
	}

	handleNextPreview = async boxOfficeVideos => {
		this.setState({ disablePrev: false, disableNext: true })
		if (boxOfficeVideos[this.state.count].type === 'content') {
			await this.ContentAnalytics(boxOfficeVideos[this.state.count])
		} else {
			await this.VideoAnalytics(boxOfficeVideos[this.state.count])
		}

		const finalcount = this.state.count
		if (finalcount === boxOfficeVideos.length - 1) {
			const nextSet = true
			await this.GetBoxOfficeVideos(nextSet)
			this.setState({ count: finalcount + 1, disableNext: false })
		} else {
			this.setState({ count: finalcount + 1, disableNext: false })
		}
	}

	render() {
		const { boxOfficeVideos, disablePrev, disableNext } = this.state
		const height = (boxOfficeVideos.length > 0 && boxOfficeVideos[this.state.count].type === 'content' && boxOfficeVideos[this.state.count].contentType === 'Story') ? '92%' : '102%'
		return (
			<section>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<div style={{ marginBottom: 10, marginTop: 10 }}>
					<Button
						onClick={() => {
							this.ClearUserHistory()
						}}
					>
						Clear User History
					</Button>
				</div>

				<div style={{ display: 'flex' }}>
					<div style={{ marginTop: 320 }}>
						<Button
							style={{ marginRight: 20 }}
							onClick={() => {
								this.handlePreviousPreview(boxOfficeVideos)
							}}
							disabled={disablePrev}
						>
							{'<'}
						</Button>
					</div>
					{boxOfficeVideos && boxOfficeVideos.length ? (
						<div>
							{boxOfficeVideos[this.state.count] &&
								boxOfficeVideos[this.state.count].type === 'content' ? (
								<div style={{ height: heightPercentageToDP('100%') }}>
									<div
										style={{
											height: heightPercentageToDP(height),
											width: widthPercentageToDP('100%'),
											borderStyle: 'solid',
											position: 'relative',
										}}
									>
										<Preview
											data={boxOfficeVideos[this.state.count]}
											contentSelectedLangVal={
												boxOfficeVideos[this.state.count].contentLanguages
													? boxOfficeVideos[this.state.count].contentLanguages[0]
													: boxOfficeVideos[this.state.count].contentLanguage
														? boxOfficeVideos[this.state.count].contentLanguage.substr(0, 2)
														: null
											}
											type={'clearUserHistory'}
										/>
									</div>
								</div>
							) : (
								<div style={{ height: heightPercentageToDP('100%') }}>
									<div
										style={{
											height: heightPercentageToDP('101%'),
											width: widthPercentageToDP('100%'),
											borderStyle: 'solid',
											position: 'relative',
										}}
									>
										<VideoPreview
											data={boxOfficeVideos[this.state.count]}
											type={'clearUserHistory'}
										/>
									</div>
								</div>
							)}
						</div>
					) : (
						<div
							style={{
								height: heightPercentageToDP('101%'),
								width: widthPercentageToDP('100%'),
								borderStyle: 'solid',
								position: 'relative',
							}}
						>
							<p style={{ textAlign: 'center' }}>Show Preview here </p>
						</div>
					)}
					<div style={{ marginTop: 320 }}>
						<Button
							style={{ marginLeft: 20 }}
							onClick={() => {
								this.handleNextPreview(boxOfficeVideos)
							}}
							disabled={disableNext}
						>
							{'>'}
						</Button>
					</div>
				</div>
			</section>
		)
	}
}

export default ClearHistory
